import { useTranslation } from "react-i18next";

import { PLAN_NAMES } from "./content";
import { formatPrice, formatPromoUntil, priceAfterPromo } from "./pricing";
import styles from "./Planes.module.scss";

// Cómo se muestra un plan (nombre, color, leyenda de la promo). Lo usan la pantalla de Planes,
// sus modales y el formulario de suscripción, así que vive fuera de PlanCard.

export const planName = (t, plan) => {
  const name = PLAN_NAMES[plan.code];
  return name ? t(name[0], name[1]) : plan.name;
};

export const planTheme = (code) => styles[`plan_${code}`] || styles.plan_basic;

// Promo de Premium para clientes actuales (api#588, definición de Maia 02/11): paga con los
// tramos de Pro hasta la factura de `promo.until`; desde la siguiente, el precio de lista.
export function PromoNote({ plan, className }) {
  const { t } = useTranslation();
  const until = formatPromoUntil(plan.promo?.until);
  if (!until) return null;
  const after = priceAfterPromo(plan);
  return (
    <p className={className} data-testid="premium-promo">
      {after != null
        ? t("planes_premium_promo_price", "Precio de Pro hasta la factura del {{date}}. Desde la siguiente, {{price}} por agenda + IVA.", {
            date: until,
            price: formatPrice(after),
          })
        : t("planes_premium_promo", "Precio de Pro hasta la factura del {{date}}. Desde la siguiente, precio de lista de Premium.", {
            date: until,
          })}
    </p>
  );
}
